import { isProduction } from "./environment";

// eslint-disable-next-line  @typescript-eslint/no-explicit-any
export const redirectToAdminHubPaymentDetails = (error: any): boolean => {
    const adminBaseUrl = isProduction()
        ? "https://admin.atlassian.com"
        : "https://admin.stg.atlassian.com";
    const errorResponse = error.message?.trim();

    // different browsers may have different error shapes
    const errorBody = errorResponse.startsWith("Forbidden")
        ? // Firefox, eg.'Forbidden {"paymentMethodsPath":"/billing/xxxx/payment-methods"}'
          errorResponse.substring(9).trim()
        : // Chrome and others, eg.'{"paymentMethodsPath":"/billing/xxxx/payment-methods"}'
          errorResponse;

    // extract redirect url from error body
    try {
        const paymentMethodsPath = JSON.parse(errorBody)
            ?.paymentMethodsPath as string;
        if (Boolean(paymentMethodsPath)) {
            window.open(adminBaseUrl + paymentMethodsPath, "_blank");
        }
        return true;
    } catch (err) {
        console.warn("Rovo Dev Payment Redirect URL is not valid JSON");
        return false;
    }
};
